import {
  LOAD_CONTENT_BY_CAT_SLUG,
  LOAD_CONTENT_BY_CAT_SLUG_SUCCESS
} from './constants';

export function loadContentByCatSlug(catSlug, page, pageSize) {
  return {
    type: LOAD_CONTENT_BY_CAT_SLUG,
    payload: {
      catSlug,
      page,
      pageSize
    }
  };
}

export function saveLoadedContentByCatSlug(data) {
  return {
    type: LOAD_CONTENT_BY_CAT_SLUG_SUCCESS,
    payload: data,
  };
}
